import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  inline-size: 140px;
`;

export const Header = styled.div`
  color: #001246;
  font-weight: bold;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  text-transform: uppercase;
`;

export const SponsoredArticleContainer = styled.div``;
